(function ($) {
  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   */

  function initializeBlock() {
    if ($("[data-teaser]").length) {
      var myfunc = setInterval(function () {
        var arr = $("[data-teaser]").data("teaser").split(/[- :]/);
        var countDownDate = new Date(
          arr[0],
          arr[1] - 1,
          arr[2],
          arr[3],
          arr[4],
          arr[5]
        );
        var now = new Date().getTime();
        var timeleft = countDownDate - now;

        var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        if (days <= 0) {
          days = 0;
        }
        var hours = Math.floor(
          (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        if (hours <= 0) {
          hours = 0;
        }
        var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
        if (minutes <= 0) {
          minutes = 0;
        }
        var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
        if (seconds <= 0) {
          seconds = 0;
        }

        $(".days").text(("0" + days).slice(-2));
        $(".hours").text(("0" + hours).slice(-2));
        $(".minutes").text(("0" + minutes).slice(-2));
        $(".seconds").text(("0" + seconds).slice(-2));
      }, 1000);
    }
  }

  function convertDateForIos(date) {
    var arr = date.split(/[- :]/);
    date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    return date;
  }

  initializeBlock();

  if (window.acf) {
    window.acf.addAction("render_block_preview/type=faq", initializeBlock);
  }
})(jQuery);
